
import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';

import { CustomFormFieldSubmission } from '@core/objects/form';

@Component({
    selector: 'form-field-view-short-text-v1',
    templateUrl: './view-short-text-v1.component.html'
})
export class ViewShortTextV1FieldComponent implements OnInit{
    @Input() fieldSubmission: CustomFormFieldSubmission;

    ngOnInit(): void {
    }


}
